const isNoCookieMode = () => localStorage.getItem("no-cookie") === "1";

interface PurchaseEvent {
  value: number;
  contents: { id: string; quantity: number }[];
}

/**
 * Load Facebook Pixel script.
 * Prevent duplicate insertion by checking if the Facebook Pixel script element already exists.
 * Create the main Facebook Pixel script element and append it to the document head.
 * @param {string} pixelId - The ID of the Facebook Pixel.
 */
export const loadFacebookPixel = (pixelId: string): Promise<void> => {
  return new Promise((resolve) => {
    if (isNoCookieMode()) return resolve();
    if (document.getElementById("fb-pixel-script")) return resolve();

    const script = document.createElement("script");
    script.id = "fb-pixel-script";
    script.async = true;
    script.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;

    script.onload = () => {
      resolve();
    };

    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    noscript.id = "fb-pixel-noscript";
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />
    `;
    document.body.insertBefore(noscript, document.body.firstChild);

    // Resolve after a short delay to ensure fbq is ready
    setTimeout(resolve, 500);
  });
};

export function sendPurchaseEventFb({ value, contents }: PurchaseEvent) {
  if (isNoCookieMode()) return;
  if (typeof window !== "undefined" && (window as any).fbq) {
    (window as any).fbq("track", "Purchase", {
      value,
      currency: "RON",
      contents,
      content_type: "product",
    });
  }
}

/**
 * Sends a Facebook Lead event using the Facebook Pixel API.
 * The event is only sent if the Facebook Pixel API is available.
 * @param {any} client - The client object, containing firstName, lastName, email, and phone.
 * @param {any} selectedProduct - The selected product object, containing name.
 * @param {string} selectedPrice - The selected product price.
 */
export const sendLeadEventFb = (
  client: any,
  selectedProduct: any,
  seletectedPrice: string
) => {
  if (isNoCookieMode()) return;
  if (typeof window !== "undefined" && (window as any).fbq) {
    console.log("Sending FB Lead Event");
    (window as any).fbq("track", "Lead", {
      client_name: client.firstName + " " + client.lastName,
      client_email: client?.email,
      client_phone: client?.phone,
      product: selectedProduct?.name,
      value: seletectedPrice,
      currency: "RON",
    });
  }
};
